import { FinancialDocumentFilters as FinancialDocumentQueryFilters } from "@common/schemas/financialDocument/financial-document-query.schema";
import { FiltersTypes } from "@common/types/filters/general";
import { toFinancialDocumentQueryFilters } from "@common/helpers/financial-document-query-filters";

interface BuildFinancialDocumentsTaskQueryParams {
    viewFilters: FiltersTypes;
    originalFilters?: FiltersTypes;
    stickyDocumentIds?: number[];
}

export function buildFinancialDocumentsTaskQuery({
    viewFilters,
    originalFilters,
    stickyDocumentIds,
}: BuildFinancialDocumentsTaskQueryParams): FinancialDocumentQueryFilters | null {
    if (originalFilters === undefined) {
        return toFinancialDocumentQueryFilters(viewFilters);
    }
    // An empty id list means "no id filter" to the documents endpoint.
    if (!stickyDocumentIds?.length) {
        return null;
    }
    return {
        financialDocumentIds: stickyDocumentIds,
        search: viewFilters.search,
    };
}
